import { useEffect, useState } from "react";
import { Box, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import {
  CategoryMenuStyle,
  CategorySelectorStyle,
  PanelItemsContainer,
  PanelWrapper,
} from "./ptpTabs.style";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { featuresMap } from "../../../utils/features";
import {
  setTabCategoryType,
  setTabMenuType,
  reset as resetParticipantTabState,
} from "../../../Redux/reducers/participantTabSlice";
import MenuItemSelector from "./MenuItemSelector";

type MenuItemType = {
  key: string;
  label: string;
  display: boolean;
};

const MenuPanel = () => {
  const dispatch = useAppDispatch();
  const features = useAppSelector((state) => state.study.features);
  const categoryType = useAppSelector(
    (state) => state.participantTab.categoryType
  );
  const [categoryList, setCategoryList] = useState<MenuItemType[]>([]);

  useEffect(() => {
    const menuItemList: MenuItemType[] = [
      {
        key: "patient_profile",
        label: "Patient Profile",
        display: true,
      },
      // {
      //   key: "health_data",
      //   label: "Health Data",
      //   display: features?.[featuresMap.healthParameters],
      // },
      // {
      //   key: "questionnaires",
      //   label: "Questionnaire",
      //   display: features?.[featuresMap.questionnaire],
      // },
      // {
      //   key: "medication",
      //   label: "Medication",
      //   display: features?.[featuresMap.medication],
      // },
      // {
      //   key: "exercises",
      //   label: "Exercise",
      //   display: features?.[featuresMap.exercises],
      // },
      // {
      //   key: "food",
      //   label: "Food",
      //   display: features?.[featuresMap.food],
      // },
      // {
      //   key: "lab_reports",
      //   label: "Lab Reports",
      //   display: features?.[featuresMap.reports],
      // },
      // {
      //   key: "lab_test",
      //   label: "Lab Test",
      //   display: features?.[featuresMap.labTest],
      // },
      // {
      //   key: "wearables",
      //   label: "Wearables",
      //   display: features?.[featuresMap.wearable],
      // },
      // {
      //   key: "learn",
      //   label: "Learn",
      //   display: features?.[featuresMap.cms],
      // },
    ].filter((item) => item.display);
    setCategoryList(menuItemList);

    const categoryType =
      sessionStorage?.getItem("category-type") || menuItemList[0].key;

    dispatch(setTabCategoryType(categoryType));
    sessionStorage.setItem("category-type", categoryType);

    return () => {
      sessionStorage.removeItem("category-type");
      dispatch(resetParticipantTabState());
    };
  }, [dispatch, features]);

  const handleChangeType = (e: SelectChangeEvent<string>) => {
    dispatch(setTabCategoryType(e.target.value));
    dispatch(setTabMenuType(""));
    sessionStorage.setItem("category-type", e.target.value);
    sessionStorage.setItem("menu-type", "");
  };

  return (
    <Box sx={PanelWrapper}>
      {categoryList?.length > 0 && (
        <>
          <Select
            fullWidth
            value={categoryType}
            onChange={handleChangeType}
            IconComponent={ExpandMore}
            sx={CategorySelectorStyle}
            MenuProps={{
              sx: CategoryMenuStyle,
            }}
          >
            {categoryList.map((option: any) => (
              <MenuItem key={option.key} value={option.key}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <Stack gap={1} sx={PanelItemsContainer}>
            <MenuItemSelector />
          </Stack>
        </>
      )}
    </Box>
  );
};

export default MenuPanel;
